import { Field, Int, ObjectType } from '@nestjs/graphql'
import { ReferralTransactionDto } from './referralTransaction.dto'

@ObjectType()
export class ReferralTransactionsPageDto {
  @Field(t => [ReferralTransactionDto])
  items!: ReferralTransactionDto[]

  @Field()
  hasMore!: boolean

  @Field(t => Int, { nullable: true })
  nextPage?: number
}
